<template>
  <el-container>
    <el-main class="main">
      <span>导航列表</span>
      <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="toNavAdd">添加导航</el-button>
      <el-divider></el-divider>
      <el-table border :data="tableList">
        <el-table-column label="排序" prop="priority"></el-table-column>
        <el-table-column label="导航图标">
          <template slot-scope="scope">
            <el-image class="image" :src="scope.row.imgUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="导航名称" prop="name"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="修改时间" prop="updateTime"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="toNavEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteById(scope.row.id)" :loading="loading">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import {deleteArticleByIds, queryArticlePageList} from "../../../../api/system/articleSettings";
import {mapGetters} from "vuex";
import {getCompanyByAdmin} from "../../../../api/system/org-storage";

export default {
  name: "index",
  data(){
    return{
      tableList:[],
      loading:false,
      companyId:''
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.getCompanyByAdmin()
  },
  methods:{
    getList(){
      let param = {}
      param.type = 1
      param.companyId = this.companyId
      queryArticlePageList(param).then(res => {
        this.tableList = res.data.records
      }).catch(err=>{
        console.log(err)
      })
    },
    getCompanyByAdmin(){
      let param = {'id':this.currentUser.id}
      getCompanyByAdmin(param).then(res => {
        if(res.data.length > 0){
          this.companyId = res.data[0].id
        }
        this.getList()
      }).catch(err=>{
        console.log(err)
      })
    },
    deleteById(id){
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = []
        param.push(id)
        this.loading = true
        deleteArticleByIds(param).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("删除成功！");
            this.loading = false
            this.getList()
          }else{
            this.$modal.msgError("删除失败，请重试");
            this.loading = false
          }
        }).catch(()=>{
          this.loading = false
        });
      }).catch(() => {
        this.$modal.msg("已取消删除");
        this.loading = false
      });
    },
    toNavAdd() {
      this.$router.push({path: "/navAdd"});
    },
    toNavEdit(navList) {
      this.$router.push({name: "NavAdd",params:{'navList':JSON.stringify(navList)}});
    }
  }
}
</script>

<style scoped>
  .image{
    height: 60px;
  }
  .main{
    overflow: auto;
    height: 90vh;
  }
</style>
